<template>
  <div id="tapefileupload">
    <FilePond  
        allow-multiple="true" 
        :allowPaste="true"
        v-on:init="handleFilePondInit"
        v-on:updatefiles="handleFilePondUpdateFile"
    />
  </div>
</template>
<script>
import vueTapeFilePond from 'vue-filepond';
import '../../../assets/css/filepond.min.css';
import FilePondPluginTapeImagePreview from 'filepond-plugin-image-preview';
import '../../../assets/css/filepond-plugin-image-preview.min.css';

export default {
    name: 'tapefileupload',
    components: {
        FilePond: vueTapeFilePond(FilePondPluginTapeImagePreview)
    },
    data() {
        return {
            tapeFiles:[],
        }
    },
    methods: {
        handleFilePondInit () {
            console.log('FilePond(tape) has initialized')
            // FilePond instance methods are available on `this.$refs.pond`
        },
        onload (e, r) {
        },
        
        handleFilePondUpdateFile(files){
            this.tapeFiles = files.map(files => files.file);
            this.$emit('tapeFileHandler', this.tapeFiles);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/views/Common/image-upload/tapeUpload.vue